// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: 'AIzaSyDOMyWaOG8fMB5yQ0UYell45CtO_s-vBmc',
  authDomain: 'pikavolley-online.firebaseapp.com',
  databaseURL: 'https://pikavolley-online.firebaseio.com',
  projectId: 'pikavolley-online',
  storageBucket: 'pikavolley-online.firebasestorage.app',
  messagingSenderId: '16042256604',
  appId: '1:16042256604:web:2caf500ea81c36f550ec19',
  measurementId: 'G-ZCQ5ESKJQL',
};
